import React, { Component, Fragment } from 'react';
import {
    Input,
    Button,
    Row,
    Col,
    Label,
} from 'reactstrap';
import '../../Notes/Notes.css';
import { Prompt } from 'react-router-dom';

// import NotesCategoriesDisplay from './NotesCategoriesDisplay';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faPlus, faTimes, faSpinner } from '@fortawesome/free-solid-svg-icons'
// import PermissionWrapper from '../../../auth/PermissionWrapper';

class AddOpportunitiesNote extends Component {

    constructor(props) {
        super(props);
        this.state = {
            displayCategories: this.props.displayCategories,
            add: false,
            date: new Date().toLocaleDateString('en-CA', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/(\d+)\/(\d+)\/(\d+)/, '$1-$2-$3'),
            typeID: 0,
            notes: '',
            custodianIDs: [],
            unsavedChanges: false
        };
    }

    addNote = () => {
        this.props.addNote(this.state.date, this.state.typeID, this.state.notes, this.state.custodianIDs, () => {
            this.setState({
                date: new Date().toLocaleDateString('en-CA', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/(\d+)\/(\d+)\/(\d+)/, '$1-$2-$3'),
                typeID: 0,
                notes: '',
                custodianIDs: [],
                add: false,
                unsavedChanges: false
            })
        });
    }

    toggleCustodian = (custodianID) => {
        this.setState((state) => ({
            custodianIDs: state.custodianIDs.includes(custodianID)
                ? state.custodianIDs.filter(id => id !== custodianID)
                : [...state.custodianIDs, custodianID],
            unsavedChanges: true
        }));
    }

    render() {
        return (this.state.add ? <>
            <Prompt
                when={this.state.unsavedChanges}
                message="You have unsaved changes, are you sure you want to leave?"
            />
            <Row>
                <Col className='pr-2'>
                    <Input
                        type="date"
                        name="date"
                        value={this.state.date}
                        onChange={(e) => this.setState({ date: e.target.value, unsavedChanges: true })}
                    />
                </Col>
                <Col className='pl-0'>
                    {this.props.addCategoryCommentsArray.map(row => {
                        switch (row.validation) {
                            case "list":
                                return (
                                    <Fragment key={row.ID}>
                                        <Input type="select"
                                            name="typeID"
                                            value={this.state.typeID}
                                            onChange={(e) => this.setState({ typeID: parseInt(e.target.value), unsavedChanges: true })}
                                        >
                                            <option value="0">ACTIVITY</option>
                                            {row.list != null && row.list
                                                .filter(item => item.longDescription !== 'Other')
                                                .map(item => (
                                                    <option key={item.ID} value={item.ID}>{item.longDescription}</option>
                                                ))}
                                        </Input>
                                    </Fragment>
                                )
                            default:
                                return (
                                    <></>
                                )
                        }
                    })}
                </Col>
            </Row>
            <Row className='mt-2'>
                <Col>
                    <Input
                        type="textarea"
                        name="notes"
                        rows={15}
                        value={this.state.notes}
                        onChange={(e) => this.setState({ notes: e.target.value, unsavedChanges: true })}
                    />
                </Col>
            </Row>
            {(this.props.custodians || []).map(custodian => {
                const inputID = `add-sales-activity-custodian-${custodian.id}`;
                return (
                    <Row className='mt-2 align-items-center' key={custodian.id}>
                        <Col xs='auto' className='pr-0'>
                            <Input
                                id={inputID}
                                type='checkbox'
                                className='position-static ml-0'
                                checked={this.state.custodianIDs.includes(custodian.id)}
                                onChange={() => this.toggleCustodian(custodian.id)}
                            />
                        </Col>
                        <Col className='text-left'>
                            <Label for={inputID} className='mb-0'>{custodian.name}</Label>
                        </Col>
                    </Row>
                );
            })}
            <Row className='mt-2'>
                <Col>
                    <Button
                        color="success"
                        onClick={this.addNote}
                    >
                        Save
                    </Button>
                    <Button
                        color="secondary"
                        className='ml-2'
                        onClick={() => this.setState({ add: false, unsavedChanges: false })}
                    >
                        Cancel
                    </Button>
                </Col>
            </Row>
        </> :
            <Row className='mt-2'>
                <Col>
                    <Button
                        color="primary"
                        onClick={() => this.setState({ add: true })}
                    >
                        Add Sales Activity
                    </Button>
                </Col>
            </Row>
        )
    }
}

export default AddOpportunitiesNote;
